import styled from 'styled-components';

import {
  green,
  red,
  blue,
  lightGray,
  whitesmoke,
  boxShadow1,
  border1,
  gray,
  exactWhite,
  black,
} from 'utils/style/colors';
import { Box } from 'containers/Tasks/Inbox/styles';
import { SpaceBetween } from 'utils/style/extendable';
import Button from 'components/Button';
import { ComposedChart } from 'recharts';

interface IItemProps {
  active: boolean;
}

interface SettingsProps {
  fullHeight: boolean;
}

interface IBaseDatePickerContainerProps {
  width?: string;
}

interface SideBodyProps {
  editing?: boolean;
}
interface TitleWrapperProps {
  showTopBorder?: boolean;
}

export const EditorTitle = styled('div')`
  color: lightgray;
  font-size: 1rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
`;

export const EditorContainer = styled('div')`
  overflow: hidden auto;
`;

export const ReportActions = styled('div')`
  width: 100%;
  background-color: 'var(--exact-white)' !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem;
  & > * {
    flex-grow: 1;
    width: 100% !important;
  }
`;

// ReportFields styles
export const FieldItem = styled('div')`
  border: ${border1};
  margin: 0.5rem 0;
  border-radius: 10px;
  background-color: var(--exact-white);
  overflow: visible;
`;

export const FieldItemTitle = styled(SpaceBetween)`
  padding: 0.5rem;
  & > i {
    margin-inline-start: 0.5rem;
    color: ${red};
    cursor: pointer;
  }
`;

export const FieldFilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem;
`;

export const ChoiceItems = styled('ul')`
  margin: 0;
  max-height: 60vh;
  overflow: auto;
  & > li {
    padding: 0.8rem;
    border-top: 1px solid #efefef;
    border-bottom: none;
    background-color: var(--exact-white);
  }
`;

// ChartSeries
export const ViewerBox = styled('div')`
  background: ${exactWhite};
  text-align: ${(props) =>
    props.theme.direction === 'rtl' ? 'right' : 'left'};
  font-weight: 700;
  display: flex;
  flex: 0;
  align-items: flex-start;
  position: relative;
  justify-content: space-between;
`;
// ChartSeries
export const ViewerBoxActions = styled('div')`
  &:hover {
    background-color: var(--exact-white);
  }
  border-radius: 10px;
  padding: 4px;
  transition: all 300ms ease-out;
  display: flex;
  align-items: center;
`;

export const ActionIcon = styled('span')`
  color: gray;
  cursor: pointer;
`;

// ChartSetting

export const SideSetting = styled(Box)<SettingsProps>`
  padding: 0;
  overflow: ${(props) => (props.fullHeight ? 'visible' : 'hidden')};
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem !important;
`;

export const Title = styled('div')`
  display: flex;
  text-align: center;
  overflow: hidden;
`;

export const TitleItem = styled('div')<IItemProps>`
  color: ${(props) => (props.active ? green : 'gray')};
  cursor: pointer;
  padding: 0.8rem 0;
  background-color: ${(props) => (props.active ? 'white' : `${whitesmoke}`)};
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  &:first-child {
    border-top-right-radius: 6px;
  }

  &:last-child {
    border-top-left-radius: 6px;
  }
`;

export const IconItem = styled('div')`
  cursor: pointer;
  padding: 0.8rem 0;
  background-color: ${whitesmoke};
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ListItem = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.8rem 0;
  & > span {
    margin-inline-start: 10px;
  }
`;

// PrintSurvey
export const PrintInfo = styled('div')`
  width: 100%;
  background: ${blue};
  color: var('exact-white');
  padding: 5px 0;
  text-align: center;
  @media print {
    display: none;
  }
`;

export const Wrapper = styled('div')`
  // width: 900px;
  margin: 2rem auto 0;
`;

// ChartTitle
export const EditSeriesRow = styled('div')`
  // margin: 0.5rem 0;
  display: flex;
  padding: 0.5rem;
  align-items: center;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: rgb(1 1 1 / 18%);
  & > div {
    padding: 0 0.5rem;
  }
`;
export const TitleWrapper = styled('div')<TitleWrapperProps>`
  display: flex;
  justify-content: space-between;

  ${(props) =>
    props.showTopBorder &&
    `border-top: 1px solid ${lightGray};
  margin-top: 10px;
  padding-top: 5px;`}
`;
export const SeriesRow = styled('div')`
  white-space: nowrap;
  display: flex;
  text-align: right;
  color: gray;
  margin: 0 0 0.5rem 0;

  /*
  padding: 0.5rem;
*/
  //align-items: right;
  /*
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: rgb(1 1 1 / 18%);
*/
  & > div {
    padding: 2px 0.5rem;
  }
`;

// eslint-disable-next-line no-unexpected-multiline
export const BaseDatePickerContainer = styled(
  'div'
)<IBaseDatePickerContainerProps>`
  width: ${({ width }) => (width ? width : '100%')};
  text-align: center;
`;

export const ReportButton = styled(Button)`
  flex: 1;
  margin-top: 1em;
  padding: 0.75rem 0.5rem;
  border-radius: 0.5rem !important;
`;

export const DeleteReportButton = styled(Button)`
  flex: 1;
  margin-top: 1rem;
  border-radius: 0.5rem !important;
  background: var('--black');
  color: 'var(--exact-white)';

  &:hover {
    background: var('--black') !important;
    color: ${lightGray} !important;
  }
`;

export const SideBody = styled('div')<SideBodyProps>`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: calc(100% - ${(props) => (props.editing ? '0px' : '50px')});
`;

export const CollapseOrExpand = styled('div')`
  cursor: pointer;
  margin-bottom: 1rem;
  color: ${green};
  @media print {
    display: none;
  }
`;

export const InfoBoxWrapper = styled('div')`
  display: flex;
  justify-content: center;
  margin: 0.5rem;
`;

export const InfoBox = styled('div')`
  min-width: 4rem;
  min-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.bgColor ?? 'var(--black)'};
  border-radius: 0.5rem;
  font-weight: 300;
  font-size: 1.5rem;
  color: var(--exact-white);
  padding: 0.5rem;
`;

export const AddNewChartBtn = styled(Button)`
  .icon {
    margin-inline-start: 0.5rem;
  }
`;

export const Text = styled('span')`
  color: ${gray};
  display: block;
  flex: 1;
`;

export const DatePickerHeader = styled('div')`
  display: flex;
  flex: 1;
`;

export const ReportBox = styled('div')`
  border-radius: 10px;
  box-shadow: ${boxShadow1};
  background-color: var(--exact-white);
  padding: 1rem;
  margin: 0.5rem;
  // @media print {
  //   box-shadow: unset;
  //   padding: 0;
  //   margin: 0;
  // }
  position: relative;
  transition: 2s ease all;
  overflow: ${(props) =>
    !props.isFullScreen ? 'visible' : props.showMore ? 'visible' : 'hidden'};
`;

export const GridReportBox = styled('div')`
  border-radius: 10px;
  background-color: var(--exact-white);
  box-shadow: ${boxShadow1};
  padding: 1rem;
  margin: 0.5rem;
  @media print {
    box-shadow: unset;
    padding: 0;
    margin: 0;
  }
  overflow: hidden;
  grid-column-end: span 1;
  grid-row-end: span 1;
  position: relative;
  transition: 2s ease all;
  &:hover {
    overflow: visible;
    z-index: 10000;
    & > div {
      background: var(--exact-white);
    }

    & table {
      background: 'var(--exact-white)';
    }
  }
`;

export const GridContainer = styled('div')`
  display: grid;
  grid-auto-flow: dense;
  grid-auto-rows: 200px;
  grid-template-columns: repeat(6, 1fr);
  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 800px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ListContainer = styled('div')`
  height: 100%;
  /* overflow: auto;
  overflow: overlay; */
  overflow: visible;
`;

export const DashboardLinkWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  & > * {
    margin: 5px;
  }
`;

export const More = styled.p`
  position: absolute;
  bottom: 0px;
  right: 0px;
  margin: 0;
  background-color: ${blue};
  color: var(--exact-white);
  display: inline-block;
  border-radius: 10px 0px 10px 0px;
  cursor: pointer;
  padding: 1px 4px;
`;

export const DurationView = styled.div`
  display: inline-block;
  border: ${(props) =>
    props.showBorder ? `0px solid ${black}` : `1px solid ${black}`};
  font-weight: 300;
  color: ${black};
  cursor: pointer;
  border-radius: 0.5rem;
  padding: 2px 5px;
  margin: 0 3px;

  &:hover {
    color: ${exactWhite};
    background-color: ${black};
  }
`;

export const ChartTypeItem = styled.div`
  margin-bottom: 5px;
`;

export const ChartFilterWrapper = styled.div`
  padding-inline-end: 15px;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  max-width: 300px;
  max-height: 600px;
  padding-bottom: 200px;
  overflow: auto;
`;
export const ChartFilterPopup = styled.div`
  padding-inline-end: 0px;
  display: block;
  flex-wrap: wrap;
  position: relative;
  max-width: 80vw;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  & > * {
    flex: 1;
  }
`;

export const ComposedChartWithStyle = styled(ComposedChart)`
  @media print {
    & > svg {
      width: calc(100vw - 50px);
    }
  }
`;
